export const RESPONSE_QUALITY_OPTIONS = [
  "Perfect",
  "Good Enough",
  "Incomplete",
  "Incorrect",
] as const;

export type ResponseQuality = (typeof RESPONSE_QUALITY_OPTIONS)[number];
